import React, { lazy, Suspense } from 'react';
import IDMSecurityModalProps from './entities/IDMSecurityModalProps';
import { lazyRetry } from '@bimser/core';

const ContainerLazy = lazy(() =>
	lazyRetry(() => import(/* webpackChunkName: "web-dm" */ './containers')).then(
		({ default: container }) => {
			lazyRetry(() => import(/* webpackChunkName: "web-dm" */ 'modules/dm/injector'));
			return { default: container };
		}
	)
);

function Container(props: React.PropsWithChildren<IDMSecurityModalProps>) {
	return (
		<Suspense fallback={<div></div>}>
			<ContainerLazy {...props} />
		</Suspense>
	);
}

export default Container;
